import { CareerId } from '@common/const/catalog/career';
import { RangeInputValue } from '@cp/ds/src/components/form/components/field/range/model';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { FormAvailableOnlyModel } from '../../ui/availableOnly/model';

export enum FormFieldName {
  // Online = 'online',
  Price = 'price',
  ChildrenCount = 'childrenCount',
  Training = 'training',
  Baby = 'baby',
  ChildWithDisabilities = 'childWithDisabilities',
  Options = 'options',
  Age = 'age',
  DateStart = 'dateStart',
  DateEnd = 'dateEnd',
  RegularSpecialist = 'regularSpecialist',
}

export type FormModel = FormAvailableOnlyModel & {
  // [Key in FormFieldName.Online]: boolean | null;
  // } & {
  [Key in FormFieldName.Price]: RangeInputValue | null;
} & {
  [Key in FormFieldName.ChildrenCount]: number | null;
} & {
  [Key in FormFieldName.Training]: boolean | null;
} & {
  [Key in FormFieldName.Baby]: boolean | null;
} & {
  [Key in FormFieldName.ChildWithDisabilities]: boolean | null;
} & {
  [Key in FormFieldName.Age]: RangeInputValue | undefined;
} & {
  [Key in FormFieldName.DateStart]: string | null;
} & {
  [Key in FormFieldName.DateEnd]: string | null;
} & {
  [Key in FormFieldName.RegularSpecialist]: boolean | null;
} & {
  [Key in FormFieldName.Options]: number[];
};

export type FormSubmitTrigger = () => Promise<void> | void;

export const FORM_FIELDS_BASE = [FormFieldName.Age] as const;

export const FORM_FIELDS_FOR_CAREER: Record<CatalogItemType, Partial<Record<CareerId, FormFieldName[]>>> = {
  [CatalogItemType.Resume]: {
    [CareerId.Nanny]: [
      FormFieldName.Price,
      FormFieldName.ChildrenCount,
      FormFieldName.Training,
      FormFieldName.Baby,
      FormFieldName.ChildWithDisabilities,
      FormFieldName.Options,
    ],
    [CareerId.Nurse]: [FormFieldName.Price, FormFieldName.Options],
    [CareerId.Tutor]: [FormFieldName.Price, FormFieldName.Options],
    [CareerId.Housekeeper]: [FormFieldName.Price, FormFieldName.Options],
  },
  [CatalogItemType.Vacancy]: {
    [CareerId.Nanny]: [FormFieldName.Price, FormFieldName.DateStart, FormFieldName.RegularSpecialist],
    [CareerId.Nurse]: [FormFieldName.Price, FormFieldName.DateStart],
    [CareerId.Tutor]: [FormFieldName.Price, FormFieldName.DateStart],
    [CareerId.Housekeeper]: [FormFieldName.Price, FormFieldName.DateStart],
  },
};
